
import request from '@/request'
const part_url = 'recruit/web/ticket/';


/**
 * 查询咨询
 *
 * @param {*} id 准考证id
 * @param {*} recruitId 公告id
 * @returns
 */
function getTicketInfo(data) {
  let url = part_url + "getTicketInfo";
  return request.get(url, data)
}
/**
 * 查询咨询
 *
 * @param {*} id 准考证id
 * @param {*} printStatus 状态值
 * @returns
 */
function updateTicketStatus(data) {
  let url = part_url + "updateTicketStatus";
  return request.get(url, data)
}



export default {
    getTicketInfo,
    updateTicketStatus
}



// WEBPACK FOOTER //
// ./src/api/ticket.js